import {
    collection,
    getDocs,
    addDoc,
    updateDoc,
    deleteDoc,
    doc,
    setDoc
} from 'firebase/firestore';
import { db } from './config';

// Get all data
export const getAllData = async (setAvails, setLadies, setServices) => {
    try {
        // Get ladies
        const ladiesSnapshot = await getDocs(collection(db, 'ladies'));
        const ladiesData = ladiesSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        setLadies(ladiesData);

        // Get services
        const servicesSnapshot = await getDocs(collection(db, 'services'));
        const servicesData = servicesSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        setServices(servicesData);

        // Get availabilities
        const availsSnapshot = await getDocs(collection(db, 'availabilities'));
        const availsData = availsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        setAvails(availsData);
    } catch (error) {
        console.error("Error fetching data:", error);
    }
};

// Ladies CRUD operations
export const addLady = async (ladyData) => {
    try {
        const docRef = await addDoc(collection(db, 'ladies'), ladyData);
        return { id: docRef.id, ...ladyData };
    } catch (error) {
        console.error("Error adding lady:", error);
        throw error;
    }
};

export const updateLady = async (id, ladyData) => {
    try {
        const ladyRef = doc(db, 'ladies', id);
        await updateDoc(ladyRef, ladyData);
        return { id, ...ladyData };
    } catch (error) {
        console.error("Error updating lady:", error);
        throw error;
    }
};

export const deleteLady = async (id) => {
    try {
        await deleteDoc(doc(db, 'ladies', id));
        return id;
    } catch (error) {
        console.error("Error deleting lady:", error);
        throw error;
    }
};

// Services CRUD operations
export const addService = async (serviceData) => {
    try {
        const docRef = await addDoc(collection(db, 'services'), serviceData);
        return { id: docRef.id, ...serviceData };
    } catch (error) {
        console.error("Error adding service:", error);
        throw error;
    }
};

export const updateService = async (id, serviceData) => {
    try {
        const serviceRef = doc(db, 'services', id);
        await updateDoc(serviceRef, serviceData);
        return { id, ...serviceData };
    } catch (error) {
        console.error("Error updating service:", error);
        throw error;
    }
};

export const deleteService = async (id) => {
    try {
        await deleteDoc(doc(db, 'services', id));
        return id;
    } catch (error) {
        console.error("Error deleting service:", error);
        throw error;
    }
};

// Availabilities CRUD operations
export const addAvailability = async (availabilityData) => {
    try {
        const docRef = await addDoc(collection(db, 'availabilities'), availabilityData);
        return { id: docRef.id, ...availabilityData };
    } catch (error) {
        console.error("Error adding availability:", error);
        throw error;
    }
};

export const updateAvailability = async (id, availabilityData) => {
    try {
        const availRef = doc(db, 'availabilities', id);
        await updateDoc(availRef, availabilityData);
        return { id, ...availabilityData };
    } catch (error) {
        console.error("Error updating availability:", error);
        throw error;
    }
};

export const deleteAvailability = async (id) => {
    try {
        await deleteDoc(doc(db, 'availabilities', id));
        return id;
    } catch (error) {
        console.error("Error deleting availability:", error);
        throw error;
    }
};

// Styling CRUD operations
export const updateStyling = async (styleData) => {
    try {
        const docRef = doc(db, 'styling', 'global');
        await setDoc(docRef, styleData, { merge: true });
        return true;
    } catch (error) {
        console.error("Error updating styling:", error);
        throw error;
    }
};